import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminGuard } from './components/AdminGuard';
import { AdminLayout } from './components/AdminLayout';
import { AuditGuard } from './components/AuditGuard';
import { AuthGuard } from './components/AuthGuard';
import { ThemeProvider } from './contexts/ThemeContext';
import { WebAuthProvider } from './contexts/WebAuthContext';
import { DashboardPage, TaskDetailPage, UserDetailPage, UsersPage } from './pages/admin';
import { CallbackPage } from './pages/CallbackPage';
import { DownloadPage } from './pages/DownloadPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { SignInPage } from './pages/SignInPage';
import { SignUpPage } from './pages/SignUpPage';
import { WebLoginPage } from './pages/WebLoginPage';
import { WebSignUpPage } from './pages/WebSignUpPage';

export function App() {
  return (
    <ThemeProvider>
      <WebAuthProvider>
        <Routes>
          {/* ルートへのアクセスは /download へリダイレクト */}
          <Route path="/" element={<Navigate to="/download" replace />} />

          {/* ダウンロードページ（認証必須） */}
          <Route
            path="/download"
            element={
              <AuthGuard>
                <DownloadPage />
              </AuthGuard>
            }
          />

          {/* Webログインページ（ダウンロードページ用） */}
          <Route
            path="/login"
            element={
              <div className="min-h-screen flex items-center justify-center p-4">
                <WebLoginPage />
              </div>
            }
          />

          {/* Webサインアップページ（ダウンロードページ用） */}
          <Route
            path="/signup"
            element={
              <div className="min-h-screen flex items-center justify-center p-4">
                <WebSignUpPage />
              </div>
            }
          />

          {/* 認証関連ページ（アプリ向け） */}
          <Route
            path="/auth/signin"
            element={
              <div className="min-h-screen flex items-center justify-center p-4">
                <SignInPage />
              </div>
            }
          />
          <Route
            path="/auth/signup"
            element={
              <div className="min-h-screen flex items-center justify-center p-4">
                <SignUpPage />
              </div>
            }
          />
          <Route
            path="/auth/forgot-password"
            element={
              <div className="min-h-screen flex items-center justify-center p-4">
                <ForgotPasswordPage />
              </div>
            }
          />
          <Route
            path="/auth/callback"
            element={
              <div className="min-h-screen flex items-center justify-center p-4">
                <CallbackPage />
              </div>
            }
          />

          {/* 管理者ダッシュボード（admin/audit グループ必須） */}
          <Route
            path="/admin"
            element={
              <AdminGuard>
                <AdminLayout />
              </AdminGuard>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="users/:email" element={<UserDetailPage />} />
            {/* タスク詳細は audit グループ必須 */}
            <Route
              path="users/:email/tasks/:taskId"
              element={
                <AuditGuard>
                  <TaskDetailPage />
                </AuditGuard>
              }
            />
          </Route>
        </Routes>
      </WebAuthProvider>
    </ThemeProvider>
  );
}
